<template>
  <div class="partner-ob-wrapper">
    <VerticalProgressBar v-if="shouldShowVerticalProgress" />
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import VerticalProgressBar from '../../components/globalUiComponents/VerticalProgressBar.vue'

export default {
  name: 'PartnerOnboarding',
  components: {
    VerticalProgressBar
  },
  computed: {
    activeRoute () {
      return this.$route.name
    },
    shouldShowVerticalProgress () {
      const HIDDEN_ROUTES = ['login']
      return !HIDDEN_ROUTES.includes(this.activeRoute)
    }
  }
}
</script>

<style lang="css" scoped>
.partner-ob-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.partner-ob-wrapper .navbar {
  width: 317px;
  height: 100%;
  background-color: #e2e2e2;
}
.partner-ob-wrapper .main-content {
  flex-grow: 1;
  height: 100%;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/PartnerOnboarding.vue